var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "paper-dialog",
          attrs: {
            title: "Edit Content",
            visible: _vm.dialogVisible,
            width: "50vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            close: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              staticClass: "padding-lr",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "210px",
                "element-loading-text": "loading...",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Content Category", prop: "categoryId" } },
                [
                  _c(
                    "div",
                    { staticClass: "cate-select-add" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Please select content category",
                          },
                          model: {
                            value: _vm.form.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "categoryId", $$v)
                            },
                            expression: "form.categoryId",
                          },
                        },
                        _vm._l(_vm.categoryList, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: {
                                label: item.CategoryName,
                                value: item.PaperCategoryID,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "select-option-item",
                                  attrs: { title: item.CategoryName },
                                },
                                [_vm._v(" " + _vm._s(item.CategoryName) + " ")]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: { click: _vm.showCateDialog },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Short Title", prop: "shortTitle" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input short title",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.shortTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "shortTitle", $$v)
                      },
                      expression: "form.shortTitle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Search Term", prop: "searchTerm" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input search term",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.searchTerm,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "searchTerm", $$v)
                      },
                      expression: "form.searchTerm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Allow Full Article Request",
                    prop: "fullPaperRequest",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.fullPaperRequest,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fullPaperRequest", $$v)
                        },
                        expression: "form.fullPaperRequest",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("Yes")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("No")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.data
                ? [
                    _c("el-form-item", { attrs: { label: "Any Comments" } }, [
                      _c("div", { staticClass: "any-comments-wrapper" }, [
                        _vm._v(_vm._s(_vm.data.AnyComments)),
                      ]),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "push-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(" Submit ")]
              ),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.onClosed } },
                [_vm._v(" Cancel ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("NewCategoryDialog", {
        attrs: { visible: _vm.addCategoryDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.addCategoryDialogVisible = $event
          },
          success: _vm.onNewCateSuccess,
          closed: _vm.onNewCateClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }